"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTEXT_MAP = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonBody = _interopRequireDefault(require("../components/Comparison/ComparisonBody"));
var _ComparisonHeader = _interopRequireDefault(require("../components/Comparison/ComparisonHeader"));
var _DynamicPageBodyFactory = _interopRequireDefault(require("../components/DynamicPage/DynamicPageBodyFactory"));
var _DynamicPageHeaderFactory = _interopRequireDefault(require("../components/DynamicPage/DynamicPageHeaderFactory"));
var _ErrorBody = _interopRequireDefault(require("../components/Error/ErrorBody"));
var _ErrorHeader = _interopRequireDefault(require("../components/Error/ErrorHeader"));
var _QuestionFooter = require("../components/Questionnaire/QuestionFooter");
var _QuestionHeader = require("../components/Questionnaire/QuestionHeader");
var _QuestionnaireBody = _interopRequireDefault(require("../components/Questionnaire/QuestionnaireBody"));
var _RecommendationBodyWrapper = _interopRequireDefault(require("../components/Recommendation/RecommendationBodyWrapper"));
var _RecommendationHeaderTop = _interopRequireDefault(require("../components/Recommendation/RecommendationHeaderTop"));
var _RecommendationErrorPageBodyFactory = _interopRequireDefault(require("../components/RecommendationError/RecommendationErrorPageBodyFactory"));
var _RecommendationErrorPageHeaderFactory = _interopRequireDefault(require("../components/RecommendationError/RecommendationErrorPageHeaderFactory"));
var _HeaderTop = _interopRequireDefault(require("../components/shared/HeaderTop"));
var _SummaryBody = _interopRequireDefault(require("../components/Summary/SummaryBody"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CONTEXT_MAP = {
  QUESTIONNAIRE: {
    header: /*#__PURE__*/_react.default.createElement(_QuestionHeader.QuestionHeader, null),
    body: /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null),
    footer: /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null)
  },
  SUMMARY: {
    header: /*#__PURE__*/_react.default.createElement(_HeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_SummaryBody.default, null)
  },
  RECOMMENDATION: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationHeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationBodyWrapper.default, null)
  },
  ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_ErrorHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_ErrorBody.default, null)
  },
  COMPARISON: {
    header: /*#__PURE__*/_react.default.createElement(_ComparisonHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_ComparisonBody.default, null)
  },
  DYNAMIC: {
    header: /*#__PURE__*/_react.default.createElement(_DynamicPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_DynamicPageBodyFactory.default, null)
  },
  RECOMMENDATION_ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageBodyFactory.default, null)
  }
};
exports.CONTEXT_MAP = CONTEXT_MAP;